import React from 'react'
import Icon from 'srcReact/components/icons/Icon'
import GroupMillPure from './GroupMillPure'
import styles from './styles.module.scss'

function GroupMixrPill({ type, groupType = 'interest', picture, size = 'medium', iconName = 'calendar24' }) {
  return (
    <GroupMillPure
      type={type}
      groupType={groupType}
      picture={picture}
      size={size}
      renderIcon={() => <Icon name={iconName} />}
    />
  )
}

export default GroupMixrPill
